(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["content-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'load',
    (event) => {
      const img = event.target;
      if (!(img instanceof HTMLImageElement)) return;
      if (!img.classList.contains('custom-image-content__img')) return;
      const box = img.closest('.custom-image-content');
      if (box) box.classList.add('is-loaded');
    },
    true
  );

  document.querySelectorAll('.custom-image-content__img').forEach((img) => {
    if (img.complete && img.naturalWidth > 0) {
      const box = img.closest('.custom-image-content');
      if (box) box.classList.add('is-loaded');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
